import React, { Component } from 'react'

import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import { Box, Button, Card, CardContent, CardHeader, Tooltip } from '@mui/material'

import CampaignBannerCreate from 'components/campaign-banners/CampaignBannerCreate'
import { Table } from 'components/table/index'
import type { BannerType } from 'models/campaign-banners-model'

import CampaignBannerCode from './CampaignBannerCode'
import CampaignBannersTableActions from './CampaignBannersTableActions'

type CampaignBannersTableProps = {
  banners: any
  customerId: number
  id: string
  title: string
  type: BannerType
}

type CampaignBannersTableState = {
  open: boolean
}

export default class CampaignBannersTable extends Component<CampaignBannersTableProps, CampaignBannersTableState> {
  state: CampaignBannersTableState = {
    open: false,
  }

  config = ({ id: campaignId, customerId } = this.props) => [
    {
      title: 'Title',
      field: 'title',
      render: ({ unsupported, title }: any) => (
        <Box sx={{ display: 'flex', alignItems: 'center', overflowWrap: 'anywhere' }}>
          <span>{title}</span>
          {unsupported && (
            <Tooltip title="Banner unsupported">
              <ReportProblemIcon sx={{ ml: '10px', color: '#ff776f' }} />
            </Tooltip>
          )}
        </Box>
      ),
    },
    {
      title: 'Width',
      field: 'width',
    },
    {
      title: 'Height',
      field: 'height',
    },
    {
      title: 'Filename',
      render: ({ filename }: any) => (
        <Box sx={{ overflowWrap: 'anywhere' }}>
          <span>{filename}</span>
        </Box>
      ),
    },
    {
      title: 'URL append',
      render: ({ urlAppend }: any) => <CampaignBannerCode text={urlAppend} />,
    },
    {
      title: 'Impression pixel',
      render: ({ impressionPixel }: any) => <CampaignBannerCode text={impressionPixel} />,
    },
    {
      title: 'Click pixel',
      render: ({ clickPixel }: any) => <CampaignBannerCode text={clickPixel} />,
    },
    {
      title: 'Actions',
      render: (banner: any) => (
        <CampaignBannersTableActions banner={banner} campaignId={campaignId} customerId={customerId} />
      ),
    },
  ]

  handleClose = (callback = () => {}) => this.setState({ open: false }, callback)

  handleOpen = () => this.setState({ open: true })

  render() {
    const { banners, customerId, id, title, type } = this.props
    const { open } = this.state

    const action = (
      <Button color="primary" onClick={this.handleOpen}>
        Add new
      </Button>
    )

    return (
      <Card>
        <CardHeader action={action} title={title} />
        <CardContent>
          <Table config={this.config()} data={banners} />
        </CardContent>

        {open && (
          <CampaignBannerCreate customerId={customerId} id={id} onClose={this.handleClose} open={open} type={type} />
        )}
      </Card>
    )
  }
}
